import { Container, css, styled } from "@mui/material";

import { getColor } from "@hooks";

export const SubheaderContainerStyled = styled(Container)(
  ({ theme }) => css`
    ${theme.breakpoints.up("mobile")} {
      padding: 16px;
    }

    ${theme.breakpoints.up("tablet")} {
      padding: 8px 64px;
      max-width: ${theme.breakpoints.values.tablet}px;
    }

    ${theme.breakpoints.up("desktop")} {
      padding: 8px 108px;
      max-width: ${theme.breakpoints.values.desktop}px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      padding: 8px 108px;
      max-width: ${theme.breakpoints.values.desktopXl}px;
    }

    margin-left: auto;
    margin-right: auto;
  `,
);

export const FirstLineStyled = styled("div")(
  ({ theme }) => css`
    font-family:
      Work Sans,
      sans-serif;

    ${theme.breakpoints.up("mobile")} {
      font-size: 22px;
      font-weight: 500;
      line-height: 28px;
    }

    ${theme.breakpoints.up("tablet")} {
      font-size: 20px;
      font-weight: 600;
      line-height: 30px;
    }

    ${theme.breakpoints.up("desktop")} {
      font-size: 22px;
      font-weight: 600;
      line-height: 32px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      font-size: 22px;
      font-weight: 600;
      line-height: 32px;
    }

    color: ${getColor(c => c.tokens.text["strong-950"], theme)};
  `,
);

export const SecondLineStyled = styled("div")(
  ({ theme }) => css`
    font-family: Work Sans;
    color: ${getColor(c => c.tokens.text["sub-600"], theme)};

    ${theme.breakpoints.up("mobile")} {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }

    ${theme.breakpoints.up("tablet")} {
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
    }

    ${theme.breakpoints.up("desktop")} {
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
    }

    ${theme.breakpoints.up("desktopXl")} {
      font-size: 20px;
      font-weight: 500;
      line-height: 30px;
    }
  `,
);
